module.exports = __webpack_public_path__ + "static/media/logo-dark.0729f358.png";